var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgupload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M16 5.5L19 2.5M19 2.5L22 5.5M19 2.5V8.5M12.5 3.5H7.8C6.11984 3.5 5.27976 3.5 4.63803 3.82698C4.07354 4.1146 3.6146 4.57354 3.32698 5.13803C3 5.77976 3 6.61984 3 8.3V16.7C3 18.3802 3 19.2202 3.32698 19.862C3.6146 20.4265 4.07354 20.8854 4.63803 21.173C5.27976 21.5 6.11984 21.5 7.8 21.5H17C17.93 21.5 18.395 21.5 18.7765 21.3978C19.8117 21.1204 20.6204 20.3117 20.8978 19.2765C21 18.895 21 18.43 21 17.5M10.5 9C10.5 10.1046 9.60457 11 8.5 11C7.39543 11 6.5 10.1046 6.5 9C6.5 7.89543 7.39543 7 8.5 7C9.60457 7 10.5 7.89543 10.5 9ZM14.99 12.4181L6.53115 20.108C6.05536 20.5406 5.81747 20.7568 5.79643 20.9442C5.77819 21.1066 5.84045 21.2676 5.96319 21.3755C6.10478 21.5 6.42628 21.5 7.06929 21.5H16.456C17.8951 21.5 18.6147 21.5 19.1799 21.2582C19.8894 20.9547 20.4547 20.3894 20.7582 19.6799C21 19.1147 21 18.3951 21 16.956C21 16.4717 21 16.2296 20.9471 16.0042C20.8805 15.7208 20.753 15.4554 20.5733 15.2264C20.4303 15.0442 20.2412 14.8929 19.8631 14.5905L17.0658 12.3527C16.6874 12.0499 16.4982 11.8985 16.2898 11.8451C16.1061 11.798 15.9129 11.8041 15.7325 11.8627C15.5279 11.9291 15.3486 12.0921 14.99 12.4181Z",
    stroke: "#696974",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgupload);
export default __webpack_public_path__ + "static/media/imgupload.d0cf4a8c164d298ef98e3cbc67aeb96b.svg";
export { ForwardRef as ReactComponent };